<template>
  <v-container>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>
    <v-row class="mt-10">
      <v-col class="text-tcdc-green text-uppercase bold header pt-0">{{ branchName }}</v-col>
    </v-row>
    <v-row id="news-list">
      <v-col class="text-tcdc-green text-uppercase bold header">{{$t('about.news')}}</v-col>
    </v-row>
    <div v-if="news && news.length > 0">
      <v-row>
        <template v-for="(item,i) of news">
          <v-col :key="i" cols="12" md="6">
            <NewsCard
                :border="parseInt(item) <= 4-2"
                :image="item.image_path"
                :title="item[`title_${lang}`]"
                :description="item[`intro_${lang}`]"
                :date="item[`publish_date_${lang}`] | moment('DD MMM YYYY')"
                :viewer="item.viewer"
                class="cursor-pointer"
                @click.native="newsHandler(item.news_id)"
            />
          </v-col>
        </template>
      </v-row>
      <div class="d-flex justify-end">
        <v-pagination
            v-model="newsPage.current_page"
            :length="newsPage.last_page"
            total-visible="7"
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            color="#2e8037"
            @input="(event) => {changePage(event); $vuetify.goTo('#news-list');}"
        ></v-pagination>
      </div>
    </div>
    <div v-else class="text-center">
      {{ $t('article.noAnyItem') }}
    </div>

  </v-container>
</template>

<script>
import NewsCard from "../../components/cards/NewsCard";
import { mapState } from "vuex";
import Loading from 'vue-loading-overlay';
import {BreadcrumbUtil} from "@/util/BreadcrumbUtil";
import {Utils} from "@/util/Utils";

export default {
  components: {
    NewsCard,
    Loading
  },
  created() {
    this.items = BreadcrumbUtil.setServiceItem(
        this.items,
        this.branchId,
        this.branchName,
        this.allBranches,
        this.lang
    )
    this.$store.dispatch('About/getAboutNewsByBranch', {
      id: this.branchId,
      lang: this.lang
    })
  },
  computed: {
    ...mapState({
      branchName: state => state.Branch.branch_name,
      allBranches: state => state.Branch.branches,
      branchId: state => state.Branch.branch_id,
      news: state => state.About.news.data,
      newsPage: state => state.About.news,
      lang: state => state.Branch.lang
    }),
    branchChanged: function () {
      return this.branchName;
    }
  },
  watch: {
    branchChanged: function() {
      this.items = BreadcrumbUtil.setServiceItem(
          this.items,
          this.branchId,
          this.branchName,
          this.allBranches,
          this.lang
      )
      this.$store.dispatch('About/getAboutNewsByBranch', {
        id: this.branchId,
        lang: this.lang
      })
    }
  },
  data: () => ({
    isLoading: false,
    items: [
      {
        text: 'TCDC BANGKOK',
        to: "/home/:branch"
      },
      {
        text: "ABOUT",
        disabled: false,
        to: "/:branch/about"
      },
      {
        text: "NEWS",
        disabled: true
      }
    ]
  }),
  methods: {
    newsHandler(id) {
      const branch = Utils.getBranchNameById(this.branchId, this.allBranches);
      this.$router.push(`/${this.lang}`+`${branch}/about/news/${id}`);
    },
    changePage(page) {
      this.isLoading = true;
      this.$store.dispatch('About/getAboutNewsByPage', { id: this.branchId, page: page })
              .then(()=>{
                this.isLoading = false;
              });
    }
  }
};
</script>

<style scoped lang="scss">

</style>
